import { useTranslation } from 'react-i18next'
import { PrometheusAlert, RuuviTag, RuuviTagCondition } from '../types'
import RuuviTagStats from './RuuviTagStats'
import { AlertRuleName } from '../enums'
import { translateAlertRuleName } from '../utils/alert'

interface RuuviTagPressureStatsProps {
  ruuviTag: RuuviTag
  ruuviTagCondition: RuuviTagCondition | null
  alerts?: PrometheusAlert[]
  loading?: boolean
}

export default function RuuviTagPressureStats({
  ruuviTag,
  ruuviTagCondition,
  alerts = [],
  loading = false
}: RuuviTagPressureStatsProps) {
  /**
   * The translate function.
   */
  const { t } = useTranslation()

  /**
   * The pressure alerts.
   */
  const pressureAlerts = alerts.filter(
    (alert) =>
      alert.labels.alertname === AlertRuleName.LOW_PRESSURE ||
      alert.labels.alertname === AlertRuleName.HIGH_PRESSURE
  )

  /**
   * Indicates if there is an active pressure alert.
   */
  const isPressureAlerting = pressureAlerts && pressureAlerts.length > 0

  /**
   * The latest pressure alert.
   */
  const latestPressureAlert =
    pressureAlerts && pressureAlerts.length > 0 ? pressureAlerts[0] : undefined

  return (
    <RuuviTagStats
      ruuviTag={ruuviTag}
      title={t('pressure')}
      value={ruuviTagCondition?.pressureAvg}
      unit="hPa"
      date={ruuviTagCondition?.time}
      loading={loading}
      alerting={isPressureAlerting}
      alertText={
        latestPressureAlert && translateAlertRuleName(latestPressureAlert.labels.alertname)
      }
    />
  )
}
